import { render, staticRenderFns } from "./portraitAlert.vue?vue&type=template&id=7073ec2b&scoped=true"
import script from "./portraitAlert.vue?vue&type=script&lang=js"
export * from "./portraitAlert.vue?vue&type=script&lang=js"
import style0 from "./portraitAlert.vue?vue&type=style&index=0&id=7073ec2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7073ec2b",
  null
  
)

export default component.exports